module.exports = __webpack_public_path__ + "img/step2-1.878b7813.png";